import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-papi-types';
import { actionKey } from './constants';

export const requestClose = createAction(`${actionKey}.REQUEST_CLOSE`, () => ({}));
export const fetchCollections = createAction(`${actionKey}.FETCH`, streamId => ({ streamId }));

export const initializeDeviation = createAction(
  `${actionKey}.INITIALIZE_DEVIATION`,
  (
    deviationId: number,
    isPrivateCollections: boolean,
    faveCount: number,
    preselectDefaultFolder?: boolean,
    ignorePreselectedCollections?: boolean
  ) => ({
    deviationId,
    isPrivateCollections,
    faveCount,
    preselectDefaultFolder,
    ignorePreselectedCollections,
  })
);

export const initializeDeviationCollections = (
  deviationId: number,
  isPrivateCollections: boolean,
  collectionids: number[],
  faveCount: number,
  preselectDefaultFolder: boolean | undefined = false,
  ignorePreselectedCollections: boolean | undefined = false
) =>
  initializeDeviationCollectionsCustom(deviationId, {
    isPrivateCollections,
    collectionids,
    faveCount,
    preselectDefaultFolder,
    ignorePreselectedCollections,
  });

export const initializeDeviationCollectionsCustom = createAction(
  `${actionKey}.INITIALIZE_DEVIATION_COLLECTIONS`,
  (
    deviationId: number,
    options: {
      isPrivateCollections: boolean;
      collectionids: number[];
      faveCount: number;
      preselectDefaultFolder: boolean;
      ignorePreselectedCollections: boolean;
    }
  ) => ({
    deviationId,
    ...options,
  })
);

export const toggleCollection = createAction(
  `${actionKey}.TOGGLE_COLLECTION`,
  (folderId: number, deviationId: number, isPrivateCollections: boolean) => ({
    folderId,
    deviationId,
    isPrivateCollections,
  })
);
export const undoChanges = createAction(`${actionKey}.UNDO`, (deviationId: number) => ({
  deviationId,
}));
export const commitCollections = createAction(
  `${actionKey}.COMMIT_COLLECTIONS`,
  (deviation: PapiDeviation) => ({ deviation, notificationQueue: 'default' })
);
export const commitCollectionsCustom = createAction(
  `${actionKey}.COMMIT_COLLECTIONS`,
  (deviation: PapiDeviation, notificationQueue: string, isPrivateCollections) => ({
    deviation,
    notificationQueue,
    isPrivateCollections,
  })
);
export const commitCollectionsSuccess = createAction(
  `${actionKey}.COMMIT_COLLECTIONS.SUCCESS`,
  (folderIds: number[], deviationId: number, entities) => ({
    folderIds,
    deviationId,
    entities,
  })
);
export const commitCollectionsFail = createAction(
  `${actionKey}.COMMIT_COLLECTIONS.FAIL`,
  (folderIds: number[], deviationId: number) => ({
    folderIds,
    deviationId,
  })
);
export const createCollection = createAction(
  `${actionKey}.CREATE_COLLECTION`,
  (name: string, selectDeviationId: number, isPrivateCollections: boolean) => ({
    name,
    selectDeviationId,
    isPrivateCollections,
  })
);
export const createCollectionSuccess = createAction(
  `${actionKey}.CREATE_COLLECTION.SUCCESS`,
  (folderId: number, entities: any) => ({ folderId, entities })
);
export const createCollectionFail = createAction(
  `${actionKey}.CREATE_COLLECTION.FAIL`,
  (name: string) => ({ name })
);

export const changeFave = createAction(
  `${actionKey}.CHANGE_FAVE`,
  (deviation: PapiDeviation, to: boolean) => ({
    deviation,
    to,
    notificationQueue: 'default',
  })
);
export const changeFaveCustom = createAction(
  `${actionKey}.CHANGE_FAVE`,
  (deviation: PapiDeviation, to: boolean, notificationQueue: string) => ({
    deviation,
    to,
    notificationQueue,
  })
);
export const changeFaveSuccess = createAction(
  `${actionKey}.CHANGE_FAVE.SUCCESS`,
  (deviationId: number, to: boolean) => ({ deviationId, to })
);
export const changeFaveFail = createAction(
  `${actionKey}.CHANGE_FAVE.FAIL`,
  (deviationId: number) => ({ deviationId })
);
export const collectFave = createAction(
  `${actionKey}.COLLECTFAVE`,
  (deviation: PapiDeviation, notificationQueue: string, actionBarType: string) => ({
    deviation,
    notificationQueue,
    actionBarType,
  })
);
export const setFaveState = createAction(
  `${actionKey}.SET_FAVE`,
  (deviation: PapiDeviation, to: boolean) => ({ deviation, to })
);
export const resetJustFaved = createAction(
  `${actionKey}.RESET_JUST_FAVED`,
  (deviationId: number) => ({ deviationId })
);

export const setPrivatelyCollectedState = createAction(
  `${actionKey}.SET_PRIVATELY_COLLECTED`,
  (deviation: PapiDeviation, to: boolean) => ({ deviation, to })
);
